<div class="table-header py-3 px-3">
    <div class="header-content">
        <h2 class="table-title">{{ 'app.billing.licences.roster.title' | translate }}</h2>
        <button mat-icon-button (click)="reload.emit()"
            class="d-flex align-items-center justify-content-center focus-outline-none"
            [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="isLoading()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
    @if (licences().length) {
    <div class="count-line">
        <span class="count-badge">{{ licences().length }}</span>
        <span class="count-label">{{ 'app.billing.licences.roster.found_suffix' | translate }}</span>
    </div>
    }
</div>

<div class="table-wrapper">
    <table mat-table [dataSource]="dataSource()">
        <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.index' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="component">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.component' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ componentLabelKey(row.component_type) | translate }}</td>
        </ng-container>

        <ng-container matColumnDef="holder">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.holder' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                {{ row.holder_name ?? ('app.billing.licences.roster.unassigned' | translate) }}
            </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.email' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                @if (row.holder_email) {
                <app-table-copy-cell [content]="row.holder_email"
                    [tooltipText]="'app.billing.licences.roster.columns.email' | translate"></app-table-copy-cell>
                } @else {
                <span class="av-billing-note">{{ 'shared.general.labels.na' | translate }}</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="assigned">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.assigned_at' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                {{ (row.assigned_at | date: 'dd/MM/yyyy') ?? ('shared.general.labels.na' | translate) }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.status' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                @if (row.cancels_at) {
                <span class="av-billing-badge av-billing-badge--open"
                    [matTooltip]="'app.billing.licences.states.ending_on' | translate: { date: row.cancels_at | date: 'mediumDate' }">
                    {{ 'app.billing.licences.states.ending' | translate }}
                </span>
                } @else if (row.holder_id) {
                <span class="av-billing-badge av-billing-badge--paid">
                    {{ 'app.billing.licences.states.licensed' | translate }}
                </span>
                } @else {
                <span class="av-billing-badge av-billing-badge--void">
                    {{ 'app.billing.licences.roster.unassigned' | translate }}
                </span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.licences.roster.columns.action' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                <div class="d-flex align-items-center gap-3">
                    @if (isAssignable(row)) {
                    <a class="av-licence-action" (click)="assign.emit(row)">
                        {{ 'app.billing.licences.actions.assign' | translate }}
                    </a>
                    }
                    @if (row.holder_id) {
                    <a class="av-licence-action av-licence-action--danger" (click)="release.emit(row)">
                        {{ 'app.billing.licences.actions.release' | translate }}
                    </a>
                    }
                    @if (row.cancels_at) {
                    <a class="av-licence-action" (click)="resume.emit(row)">
                        {{ 'app.billing.licences.actions.resume' | translate }}
                    </a>
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    @if (dataSource().data.length === 0) {
    <div class="no-data-content mt-5 pt-5">
        @if (isLoading()) {
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'app.billing.licences.roster.loading' | translate }}</span>
        } @else {
        <span>{{ 'app.billing.licences.roster.empty' | translate }}</span>
        }
    </div>
    }

    <app-table-loading-bar [isLoading]="isLoading()"></app-table-loading-bar>
</div>
